import { takeUntil } from "rxjs/operators";
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  NgZone,
  AfterViewChecked,
  ViewChild,
  ElementRef,
  DoCheck,
  HostListener,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import * as reducers from "../../reducers";
import { ViewportDetector } from "../../shared/viewport-detector";
import { ProductDetails } from "../../shared/interface/product-details";
// import { ProductAllDetails } from '../../shared/interface/product-all-details';
import * as productActions from "../product.actions";
import { LayoutService } from "../../shared/service/layout.service";
import { CartService } from "../../shared/service/cart.service";
import { ProductCompare } from "../../shared/interface/product-compare";
import {
  resizeImg,
  changeDRId,
  showOverlay,
  showImgError,
  getBuyButtonText,
  getPriceIntegerDot,
  getPriceDecimal,
  extractDRPriceIntegerDot,
  extractDRPriceDecimal,
  productName,
} from "../../shared/utils/utils";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";

@Component({
  selector: "product-details",
  templateUrl: "./product-details.component.html",
  styleUrls: ["./product-details.component.scss"],
})
export class ProductDetailsComponent implements OnInit, AfterViewChecked {
  @Input() screenWidth: string;
  @Input() productCompare: ProductCompare[];
  @Output() hatchOverlayDisplay = new EventEmitter();
  @Output() curViewType = new EventEmitter();
  @ViewChild("drId") drId: ElementRef;

  viewportType: string;
  layoutType: string;
  locale: string;
  thumbnailWGrid: number = 300;
  thumbnailHGrid: number = 231;
  thumbnailWListXL: number = 300;
  thumbnailHListXL: number = 231;
  thumbnailWListLG: number = 190;
  thumbnailHListLG: number = 107;
  changeDRId;
  productName;
  showImgError;
  getBuyButtonText;
  getPriceIntegerDot;
  getPriceDecimal;
  extractDRPriceIntegerDot;
  extractDRPriceDecimal;
  setBottomMargin: boolean = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  productDetails: ProductDetails[] = [];
  // productAllDetails: ProductAllDetails[] = [];
  afterViewChecked: boolean = false;
  featuredProductLoaded: boolean;
  drLoading: boolean = false;
  sessionStorageViewTypeKey: string = "-view-Type";

  constructor(
    private store: Store<reducers.State>,
    private route: ActivatedRoute,
    private viewportDetector: ViewportDetector,
    private router: Router,
    private layoutService: LayoutService,
    private cartService: CartService,
    private elRef: ElementRef,
    private translate: TranslateService
  ) {
    this.changeDRId = changeDRId;
    this.showImgError = showImgError;
    this.productName = productName;
    this.getBuyButtonText = getBuyButtonText;
    this.getPriceIntegerDot = getPriceIntegerDot;
    this.getPriceDecimal = getPriceDecimal;
    this.extractDRPriceIntegerDot = extractDRPriceIntegerDot;
    this.extractDRPriceDecimal = extractDRPriceDecimal;
    window.addEventListener(
      "orientationchange",
      () => {
        this.getViewType();
      },
      false
    );
  }

  @HostListener("window:resize") onScreenResize() {
    this.getViewType();
  }

  getViewType() {
    if (this.screenWidth === "SM") {
      this.layoutType = "grid";
      this.curViewType.emit("grid");
      this.saveViewType("grid");
    } else if (
      (this.screenWidth === "LG" || this.screenWidth === "XL") &&
      this.layoutType === "grid"
    ) {
      this.setGridBottomMargin();
    }
  }

  saveViewType(view) {
    try {
      localStorage.setItem(
        this.getCurLocale() + this.sessionStorageViewTypeKey,
        JSON.stringify(view)
      );
    } catch (e) {}
  }

  ngAfterViewChecked() {
    if (
      !this.afterViewChecked &&
      (this.productDetails.length || this.featuredProductLoaded)
    ) {
      window["hatchwidgetHelpers"].reloadScript();
      window["searchHelpers"].hideFeatured();

      //    }
      $(".js-product-item").removeData();
      // setTimeout(function () { window['appSetupHelpers'].scanPID() }, 500);

      this.afterViewChecked = true;
    }
  }

  ngOnInit() {
    var that = this;
    this.setStartViewType();
    window["searchHelpers"].hideFeatured();
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.locale = params["locale"];
    });

    this.store
      .select(reducers.getProductDetails)
      .pipe(takeUntil(this.destroy$))
      .subscribe((productDetails) => {
        this.productDetails = productDetails;
        this.afterViewChecked = false;
      });

    this.store
      .select(reducers.getSuggestedProduct)
      .pipe(takeUntil(this.destroy$))
      .subscribe((suggestedProducts) => {
        if (suggestedProducts.productDetails.length > 0) {
          this.productDetails = suggestedProducts.productDetails;
          this.afterViewChecked = false;
        }
      });

    window.addEventListener("orientationchange", this.onOrientationChange);

    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: LangChangeEvent) => {
        setTimeout(() => {
          $(".cart-main-section .cart__empty")[0] &&
            ($(".cart-main-section .cart__empty")[0].innerHTML =
              that.translate.instant("empty_cart"));
          $(".cart-main-section .cart__title")[0] &&
            ($(".cart-main-section .cart__title")[0].innerHTML =
              that.translate.instant("cart"));
          $(".cart-main-section .cart__items").each(function () {
            $(this)
              .find(".cart_remove .cart-item__remove")
              .each(function (i) {
                $(".cart_remove .cart-item__remove")[i].innerHTML =
                  that.translate.instant("remove");
              });
          });
          $(".cart-main-section .cart__checkout-button")[0] &&
            ($(".cart-main-section .cart__checkout-button")[0].innerHTML =
              that.translate.instant("checkout"));
          /*Hide featured text from all products except top 2*/

          console.log("On INIT Even after");
        }, 1000);
      });
  }

  onOrientationChange() {
    var mqp = window.matchMedia("(orientation: portrait)");
    var mql = window.matchMedia("(orientation: landscape)");
    if (/SHIELD/.test(navigator.userAgent) && (mqp.matches || mql.matches)) {
      window["hatchwidgetHelpers"].reloadScript();
      window["searchHelpers"].hideFeatured();

      $(".js-product-item").removeData();
    }
  }

  setStartViewType() {
    if (this.screenWidth === "SM") {
      this.layoutType = "grid";
    } else {
      this.retrieveViewType();
    }
    this.setGridBottomMargin();
  }

  retrieveViewType() {
    let view = "";
    try {
      view = JSON.parse(
        localStorage.getItem(
          this.getCurLocale() + this.sessionStorageViewTypeKey
        )
      );
    } catch (e) {}
    if (view === "grid" || view === "list") {
      this.layoutType = view;
    } else {
      this.layoutType = "list";
    }
    this.curViewType.emit(this.layoutType);
  }

  getCurLocale(): string {
    return window.location.pathname.split("/")[1];
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  fpLoaded(data) {
    this.featuredProductLoaded = data;
  }

  sendData(data: string) {
    this.layoutType = data;
    this.setGridBottomMargin();

    window["hatchwidgetHelpers"].reloadScript();
    window["searchHelpers"].hideFeatured();
    //  }
    $(".js-product-item").removeData();

    this.afterViewChecked = true;
    this.saveViewType(this.layoutType);
  }

  setGridBottomMargin() {
    this.setBottomMargin = false;
    if (this.layoutType === "grid") {
      this.setBottomMargin = true;
    }
  }

  compareProduct(productDetail) {
    if (productDetail.addRemoveCompare === "Compare") {
      if (this.productCompare.indexOf(null) > -1) {
        this.store.dispatch(
          new productActions.AddComparedProduct({
            upc: productDetail.upc,
            type: productDetail.isSuggested ? 1 : 2,
          })
        );
      }
    } else {
      this.store.dispatch(
        new productActions.RemoveComparedProduct(productDetail.upc)
      );
    }
  }

  createThumbnailList(img) {
    if (window.matchMedia("(max-width: 1280px)").matches) {
      resizeImg(img, this.thumbnailWListLG, this.thumbnailHListLG, this.locale);
    } else {
      resizeImg(img, this.thumbnailWListXL, this.thumbnailHListXL, this.locale);
    }
  }

  createThumbnail(img) {
    resizeImg(img, this.thumbnailWGrid, this.thumbnailHGrid, this.locale);
  }

  showOverlay(productDetail) {
    let popupFlag = false;
    if (popupFlag == false) {
      popupFlag = true;
      showOverlay(
        productDetail,
        this.locale,
        this.store,
        this.hatchOverlayDisplay
      );
    }
  }

  getEANCode(productUPC) {
    return productUPC;
  }
  checkOfferType(bundle, offerType) {
    if (bundle) {
      try {
        return bundle.indexOf(offerType) != -1;
      } catch (err) {
        console.error(bundle);
        return false;
      }
    }
  }
  getOfferTypeText(bundle, offerType) {
    var offerArray = bundle.split("=#=");
    var offerVal = "";
    for (var oi = 0; oi < offerArray.length; oi++) {
      var offerTypeValue = offerArray[oi].split("=");

      if (offerTypeValue.length > 0 && offerTypeValue[0] === offerType) {
        offerVal = offerTypeValue[1];
      }
    }
    return offerVal;
  }
  transmitToCart() {
    this.cartService.emitChange("Data from child");
    var that = this;
    setTimeout(() => {
      $(".cart-main-section .cart__empty")[0] &&
        ($(".cart-main-section .cart__empty")[0].innerHTML =
          that.translate.instant("empty_cart"));
      $(".cart-main-section .cart__title")[0] &&
        ($(".cart-main-section .cart__title")[0].innerHTML =
          that.translate.instant("cart"));
      $(".cart-main-section .cart__items").each(function () {
        $(this)
          .find(".cart_remove .cart-item__remove")
          .each(function (i) {
            $(".cart_remove .cart-item__remove")[i].innerHTML =
              that.translate.instant("remove");
          });
      });
      $(".cart-main-section .cart__checkout-button")[0] &&
        ($(".cart-main-section .cart__checkout-button")[0].innerHTML =
          that.translate.instant("checkout"));
    }, 100);
  }
}
